module.exports = __webpack_public_path__ + "annualreview2017/static/img/optimising-power-usage-with-a-home-smart-hub.28a77e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prosumer-wide/optimising-power-usage-with-a-home-smart-hub.png
// module id = 792
// module chunks = 0